import { render, staticRenderFns } from "./PrjService.vue?vue&type=template&id=13d0b8bd&scoped=true&"
import script from "./PrjService.vue?vue&type=script&lang=ts&"
export * from "./PrjService.vue?vue&type=script&lang=ts&"
import style0 from "./PrjService.vue?vue&type=style&index=0&id=13d0b8bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d0b8bd",
  null
  
)

export default component.exports